import * as React from 'react';

export const ExpandMoreRight = ({ isActive, ...props }) => (
  <svg width={24} height={24} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M13.516 11.967 9.273 16.21a1 1 0 0 0 1.414 1.414l4.88-4.879a1.1 1.1 0 0 0 0-1.555l-4.88-4.88a1 1 0 0 0-1.414 1.415l4.243 4.242Z"
      fill={isActive ? '#28b8e0' : '#707D80'}
    />
  </svg>
);
